
import { usePrefColorSchema } from "@hooks";
import { AuthForm } from "./AuthForm";
import AuthWrapper from "./Wrapper";
import { useRouter } from "next/router";

const Login = ({ verifyCode, resetCode }) => {
    // const isAuth = useSelector(isAuthSelector)   
    const router = useRouter()
    if(resetCode) router.push(`/reset?resetCode=${resetCode}`)
    // useEffect(() => {
    //     if(isAuth) router.push('/')
    // },[isAuth])
    return (
        <AuthWrapper colorSchema={'light'} mt="-40px">
            <AuthForm verifyCode={verifyCode} verify accountActions/>
        </AuthWrapper>
    ) 
}

export default Login;
